var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE741F",
    fillRule: "evenodd",
    d: "M8 .767c3.995 0 7.233 3.238 7.233 7.233 0 3.995-3.238 7.233-7.233 7.233C4.005 15.233.767 11.995.767 8 .767 4.005 4.005.767 8 .767zM8 1.9C4.631 1.9 1.9 4.63 1.9 8c0 3.369 2.731 6.1 6.1 6.1 3.369 0 6.1-2.731 6.1-6.1 0-3.369-2.731-6.1-6.1-6.1zm0 5.533c.289 0 .527.216.562.496l.005.07v2.668c0 .313-.254.566-.567.566-.289 0-.527-.216-.562-.495l-.005-.071V8c0-.313.254-.567.567-.567zm.007-2.666c.313 0 .566.253.566.566 0 .29-.216.528-.495.563L8 5.9c-.313 0-.567-.254-.567-.567 0-.289.216-.527.496-.562l.078-.004z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfo);
export default __webpack_public_path__ + "static/media/icons_info.59041e00bf5b2255b35a9e9f08ee24a1.svg";
export { ForwardRef as ReactComponent };